import { useEffect, useRef } from 'react';
import isEqual from 'hs-lodash/isEqual';
import debounce from 'hs-lodash/debounce';
import { validateFormRouting } from 'FormsUI/utils/Routing';
const useAutosaveRouting = ({
  formRouting,
  formRoutingFromResponse,
  updateRouting
}) => {
  const formRoutingFromResponseRef = useRef(formRoutingFromResponse);
  useEffect(() => {
    formRoutingFromResponseRef.current = formRoutingFromResponse;
  }, [formRoutingFromResponse]);
  useEffect(() => {
    const debouncedUpdateRouting = debounce(updatedRouting => {
      if (updatedRouting && formRoutingFromResponseRef.current && validateFormRouting(updatedRouting) && !isEqual(updatedRouting, formRoutingFromResponseRef.current)) {
        updateRouting(updatedRouting);
      }
    }, 300);
    if (formRouting) {
      debouncedUpdateRouting(formRouting);
    }
    return () => debouncedUpdateRouting.cancel();
  }, [formRouting, updateRouting]);
};
export default useAutosaveRouting;